// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"e761016a","732":"eacca6e8"}[chunkId] + ".chunk.js";
};